"use client";
import dynamic from 'next/dynamic';

const TrainerMapPageWrapper = dynamic(() => import('./index'), {
  ssr: false,
  loading: () => (
    <div className="relative w-full h-[calc(100dvh_-_var(--header-height)_-_130px)] sm:h-[calc(100dvh_-_var(--header-height)_-_150px)] flex items-center justify-center bg-gray-100">
      <div className="flex items-center justify-center space-x-1">
        <div className="w-2 h-2 bg-black rounded-full animate-bounce"></div>
        <div className="w-2 h-2 bg-black rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
        <div className="w-2 h-2 bg-black rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
      </div>
    </div>
  )
});

export default TrainerMapPageWrapper;